import { Box, Button } from '@mui/material';
import { DesktopLayout } from 'src/layout';
import { flowUrl } from 'src/services/FlowWorkspaceService';
import { history } from 'src/utils/history';

import type { Workspace } from 'src/services/IntentService';
import type { ReactNode } from 'react';

export const projectSections = [
    { id: 'chat', title: 'Диалог' },
    { id: 'leads', title: 'Лиды' },
    { id: 'funnel', title: 'Воронка' },
    { id: 'processing', title: 'ИИ-менеджер' },
    { id: 'results', title: 'Результаты' },
    { id: 'launch', title: 'Экономика и запуск' },
];

// Compatibility screens share the cabinet navigation and theme.
export default function WorkspaceShell({
    children,
    active,
    context,
}: {
    children: ReactNode;
    projects: Workspace[];
    active: Workspace | null;
    view: string;
    loading: boolean;
    available: boolean;
    wallet: string | null;
    navigate: (view: string, id?: number) => void;
    onNew: () => void;
    onCreate: () => void;
    onSearch: () => void;
    onSettings: () => void;
    context: ReactNode;
}) {
    return (
        <DesktopLayout
            hideRightSidebar={!active}
            rightSidebar={
                active ? (
                    <Box
                        className="project-context-content"
                        sx={{ p: 3 }}
                    >
                        {context}
                    </Box>
                ) : undefined
            }
            rightSidebarTitle="Контекст потока"
        >
            <Box sx={{ px: { xs: 2, md: 0 }, pb: 3 }}>
                <Button
                    size="small"
                    onClick={() =>
                        history.push(
                            active
                                ? flowUrl({ key: 'flow=' + active.id, name: active.name, workspace: active })
                                : '/leadstream'
                        )
                    }
                    sx={{ mb: 2 }}
                >
                    ← {active ? 'К потоку лидов' : 'Потоки лидов'}
                </Button>
                {children}
            </Box>
        </DesktopLayout>
    );
}
